export default __webpack_public_path__ + "static/media/2321.5be8638c.png";